import React from 'react';

import { ITypographyProps, Variant } from './types';
import { getTypographyComponent } from './styled';

export const Typography: React.FC<ITypographyProps> = (props) => {
  const { variant, children, ...otherProps } = props;
  const TypographyComponent = getTypographyComponent(Variant[variant]);
  return <TypographyComponent {...otherProps}>{children}</TypographyComponent>;
};
